<template>
  <div class="top-tip-wrap">
    <div class="tip-container-mask" :style="{ 'z-index': this.zIndex - 1 }"></div>
    <div class="tip-container" :style="{
        width: this.width,
        height: this.height,
        'z-index': this.zIndex
      }">
      <div class="tip-container-headr">
        <img v-if="background" class="header-backicon" src="../../assets/images/tip-header-background.png" />
        <p class="header-text" :style="{ 'z-index': this.zIndex + 1 }">
          {{ this.title }}
        </p>
        <p class="header-close" :style="{ 'z-index': this.zIndex + 1 }" @click="clickRightIcon">
          <i class="el-icon-close"></i>
        </p>
        <div class="header-lettleIcon" :style="{ 'z-index': this.zIndex + 1 }">
          <slot name="image"></slot>
        </div>
      </div>
      <div class="tip-container-body" style="padding: 70px 0px 0px 0px;">
        <slot></slot>
      </div>
      <div class="tip-container-footer">
        <button @click="footTrue" v-if="showBtn">{{ this.footTitle }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconColor: {
      default: "#FFD200"
    },
    title: {
      default: 123
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    width: {
      default: "514px"
    },
    height: {
      default: "408px"
    },
    zIndex: {
      default: 5000
    },
    footTitle: {
      default: '确定'
    },
    background: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {};
  },
  computed: {},
  methods: {
    clickRightIcon () {
      this.$emit("clickClose");
    },
    footTrue () {
      this.$emit("clickTrue");
    }
  }
};
</script>

<style lang="less" scoped>
.tip-container-mask {
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.tip-container {
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  border-radius: 30px;
  // background: #0479B5;
  // border: 3px solid #0479B5;
  box-shadow: 0px 0px 6px 0px rgba(31, 109, 181, 0.45);
  // border-radius: 10px;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 174px 1fr 134px;
  .tip-container-headr {
    position: relative;
    height: 174px;
    margin-bottom: 60px;
    img.header-backicon {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    p.header-text {
      position: absolute;
      top: 24px;
      left: 50%;
      transform: translateX(-50%);

      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 40px;
      line-height: 47px;
      color: #fff;
    }
    p.header-close {
      position: absolute;
      top: 20px;
      right: 20px;

      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      color: #fff;

      cursor: pointer;
    }
    div.header-lettleIcon {
      position: absolute;
      width: 120px;
      height: 120px;

      left: 50%;
      bottom: 0;
      transform: translateX(-50%) translateY(50%);
      img.header-backicon {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .tip-container-body {
    background-color: #fff;
  }
  .tip-container-footer {
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    button {
      width: 350px;
      height: 76px;
      font-size: 32px;
      background: #4487f0;
      border-radius: 15px;
      color: #fff;
      border: none;
      margin-bottom: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tipPopUps/index.vue